'use client';

import a__default from "react";
import { Text } from "../../Text/Text.js";
function renderSuffix({ icon: IconComponent, iconPosition, iconStyle, suffix }, disabled) {
  if (IconComponent && iconPosition === "end") {
    return /* @__PURE__ */ a__default.createElement(
      IconComponent,
      {
        color: disabled ? "onLight.disabled.muted" : "onLight.icon.secondary",
        filled: iconStyle === "filled",
        size: "md"
      }
    );
  }
  if (suffix)
    return /* @__PURE__ */ a__default.createElement(
      Text,
      {
        "aria-hidden": "true",
        color: disabled ? "onLight.disabled.muted" : "onLight.text.tertiary"
      },
      suffix
    );
  return null;
}
export {
  renderSuffix
};
